import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`w100 TemplateForAiEditContent`),
  style: {}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w100 centered mt20 mb10" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs20 fw600" }, "AIが利用する質問項目を設定"),
  /*#__PURE__*/_createElementVNode("p", { class: "fs13 mt20 text-left" }, " AIに調整カレンダーを選択してもらうための質問項目を選択できます。選択しない場合、名前・メールアドレス・会社名・電話番号を除く全ての項目を判断基準とします。 ")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "mt20"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "fs13 fw600" }, "選択中：", -1)
const _hoisted_5 = { class: "fs14 fw600 fl mt3 mr5" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src", "onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mt40 fs13 fw600" }, "選択可能な質問：", -1)
const _hoisted_10 = {
  key: 1,
  class: "mt20"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  class: "fs14 ml10 fw600 fl mt3 mr5",
  style: {"margin-bottom":"0"}
}
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    (_ctx.Util.isPresent(_ctx.selectedFields))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFields, (ff, ffindex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mr10 fl llgreyBg padw5 rad3 mb5 hoverLgreyBg",
              key: ffindex
            }, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(ff.field_name), 1),
              (ff.is_special)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.$getAssetImageUrl(`/assets/icons/asta.png`),
                    width: "20",
                    height: "23",
                    class: "pointer fl mr5"
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true),
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                width: "23",
                height: "23",
                class: "pointer fl",
                onClick: ($event: any) => (_ctx.deleteLabel(ff))
              }, null, 8, _hoisted_7)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _hoisted_8,
    _hoisted_9,
    (_ctx.typeArray)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeArray, (ff, fieldindex) => {
            return (_openBlock(), _createElementBlock("li", {
              key: fieldindex,
              onClick: ($event: any) => (_ctx.clickField(ff)),
              class: "pointer pad10 hoverLgreyBg",
              style: {"border":"1px solid #eee"}
            }, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(ff.field_name), 1),
              (ff.is_special)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.$getAssetImageUrl(`/assets/icons/asta.png`),
                    width: "20",
                    height: "23",
                    class: "pointer fl mr15"
                  }, null, 8, _hoisted_13))
                : _createCommentVNode("", true),
              _hoisted_14
            ], 8, _hoisted_11))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _hoisted_15,
    _hoisted_16,
    _hoisted_17
  ]))
}